import s from './schedule-tabs.module.scss';
import classNames from 'classnames';

export const ScheduleTabs = ({ viewMode, onSwitchToMonth, onSwitchToWeek }) => (
  <div className={s.tabs}>
    <button
      className={classNames(s.tab, viewMode === 'month' && s.active)}
      onClick={onSwitchToMonth}
      type="button"
    >
      Месяц
    </button>
    <button
      className={classNames(s.tab, viewMode === 'week' && s.active)}
      onClick={onSwitchToWeek}
      type="button"
    >
      Неделя
    </button>
  </div>
);
